import { Directive, HostBinding, HostListener, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { IPortalNavigationService } from './portal-navigation.service';

/**
 * Diese Direktive entspricht von ihrem Zweck her der Router-Link-Direktive von Angular.
 * Die einzelnen Microservices "wissen" jedoch gar nicht, dass es Routing gibt sondern kennen nur den
 * abstrakten PortalNavigationService. Außerdem gibt es auch noch Speziallinks im Portal wie z.B. für Login.
 * Auch dies wird durch die Direktive und den PortalNavigationService gekapselt.
 */
@Directive({ selector: 'a[portalLink]' })
export class PortalLinkDirective implements OnChanges, OnDestroy {
    // the url displayed on the anchor element.
    @HostBinding() href: string;

    /**
     * Die URL der Portalseite oder der Name des Speziallinks (Login / Logout).
     */
    @Input() portalLink: string | string[];

    /**
     * Falls portalLink auf eine Portalseite verweist, können hier zusätzliche Parameter angegeben werden.
     */
    @Input() portalLinkParams: {};

    private subscription: Subscription;

    constructor(private navigationService: IPortalNavigationService) {
    }

    @HostListener('click')
    onClick(): boolean {
        this.navigationService.navigate(this.portalLink, this.portalLinkParams);
        return false;
    }

    ngOnChanges(changes: SimpleChanges): any {
        if (changes.portalLink ||
            // "deep equals" wegen SPP-1345
            changes.portalLinkParams &&
            JSON.stringify(changes.portalLinkParams.previousValue) !== JSON.stringify(changes.portalLinkParams.currentValue)) {
            this.updateHref();
        }
    }

    ngOnDestroy() {
        this.unsubscribe();
    }

    private updateHref(): void {
        this.unsubscribe();
        this.subscription = this.navigationService
            .getExternalUrl(this.portalLink, this.portalLinkParams)
            // Wir sind hier leider in der Observable-Hölle gelandet.
            // Es kommt in gewissen Situationen
            // ExpressionChangedAfterItHasBeenCheckedError:
            // Expression has changed after it was checked. Previous value for 'href': 'undefined'. Current value: ....
            // Workaround: asynchron machen.
            // Außerdem prüfen, ob sich wirklich etwas geändert hat. Siehe auch SPP-1345.
            .subscribe(url => {
                if (this.href !== url) {
                    setTimeout(() => this.href = url, 0)
                }
            });
    }

    private unsubscribe(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
